import { Component, EventEmitter, OnInit, Type, ChangeDetectionStrategy } from '@angular/core';
import { PgTitleComponent } from '../shared/components/title-bar/title-bar.component';
import { SharedModule } from '../shared/shared.module';
import { AuthenticationModule } from '../authentication/authentication.module';
import { RouterModule } from '@angular/router';

interface PortalNews {
  title: string;
  content: string;
  date: Date;
  author: string;
}

@Component({
  selector: 'app-sd-home',
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule, RouterModule],
})
export class HomeComponent implements OnInit, PgTitleComponent {
  subTitle: EventEmitter<string> = new EventEmitter();
  title: EventEmitter<string> = new EventEmitter();
  toolBarComponentType?: Type<any>;
  toolbarComponent: any;

  portalNews: PortalNews[] = [];

  constructor() { }

  ngOnInit(): void {
    this.title.emit('Home');
    this.subTitle.emit('');
  }
}
